import { MetaUrlGq, MetaUrlGqProps } from './MetaUrlGq';
import { UrlMatchTypeGq } from './UrlMatchTypeGq';

export interface MetaRuleGq {
  id: number;
  projectId: number;
  url: string;
  urlMatchType: UrlMatchTypeGq;
  title: string;
  h1: string;
  meta: string;
  active: boolean;
  metaUrls: MetaUrlGq[];
}

export const MetaRuleGqProps = `
  id   
  projectId
  url
  urlMatchType
  title
  h1
  meta
  active
  metaUrls { ${MetaUrlGqProps} }
`;
